import { IExtendedContext } from '../../../types/extendedContext';
import { IUserState } from '../../../../shared/ServicePickerWidget/types/reducers/user';
import { setUser, TSetUserPayload } from '../../../../shared/ServicePickerWidget/actions/user';

export const setUserHandler = (context: IExtendedContext) => (user: Partial<IUserState>) => {
  if (user) {
    context.store.dispatch(setUser(user as TSetUserPayload));
  }

  return true;
};
